import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function HashGeneratorPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Hash Generator - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free cryptographic hash generator. Generate SHA-256, SHA-384, and SHA-512 hashes for text and data.",
    "featureList": [
      "SHA-256 hash generation",
      "SHA-384 hash generation",
      "SHA-512 hash generation",
      "Checksum generation",
      "Instant hashing",
      "Copy to clipboard"
    ]
  };

  return (
    <>
      <SEO
        title="Hash Generator - SHA-256, SHA-384, SHA-512 Online | JsonToonCraft"
        description="Free cryptographic hash generator. Generate SHA-256, SHA-384, and SHA-512 hashes for text and data. Perfect for checksums and integrity verification."
        keywords="hash generator, SHA-256, SHA-384, SHA-512, crypto hash, checksum generator, hash calculator"
        canonicalUrl="https://jsontooncraft.com/dev-tools/hash-generator"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="hash" />
    </>
  );
}
